<template>
  <transition name="fade-in-linear">
    <div class="i-loading"
      @click.stop
      @mouseover.stop>
      <div class="i-loading-inner">
        <div class="i-loading-icon">
          <Icon path="loading" name="bars" type="" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from '@/components/icon'

export default {
  name: 'Loading',
  components: {
    Icon
  }
}
</script>

<style lang="less" scoped>
  @import url("~@/styles/var.less");

  .i-loading {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    cursor: wait;
    background-color: var(--background-color, rgba(255, 255, 255, .4));
    &.hidden{
      cursor: inherit;
      display: none;
    }
    & &-inner{
      width: 100%;
      height: 30px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      display: flex;
      justify-content: center;
    }
    & &-icon{
      width: 30px;
      height: 30px;
      font-size: 30px;
      color: var(--title-color, @primary)
    }
  }
</style>
